<template>
<div class="odr-popup__content">
    <slot></slot>
</div>
</template>

<script>
export default {
};
</script>
